import React from "react";
import { ClockCircleOutlined } from "@ant-design/icons";
import { HORARIO_ATENCION, SOPORTE_TEMA } from "./fasesSoporte";

/**
 * Etiqueta con el horario de atención de soporte
 */
const AvisoHorario = ({ compacto, texto = HORARIO_ATENCION, style }) => {
  if (compacto) {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 5,
          fontSize: 11,
          lineHeight: "16px",
          color: SOPORTE_TEMA.textSecondary,
          ...style,
        }}
      >
        <ClockCircleOutlined style={{ fontSize: 11, flexShrink: 0 }} />
        <span>{texto}</span>
      </span>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "5px 10px",
        borderRadius: 6,
        fontSize: 12,
        lineHeight: "16px",
        backgroundColor: "rgba(250, 140, 22, 0.10)",
        border: "1px solid rgba(250, 140, 22, 0.28)",
        color: SOPORTE_TEMA.primarioFuerte,
        ...style,
      }}
    >
      <ClockCircleOutlined style={{ fontSize: 12, flexShrink: 0 }} />
      <span>{texto}</span>
    </div>
  );
};

export default AvisoHorario;
